import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';

var useDimension = function useDimension(ref) {
  var _React$useState = React.useState({
      width: 0,
      height: 0
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    dimension = _React$useState2[0],
    setDimension = _React$useState2[1];
  React.useEffect(function () {
    var getDimension = function getDimension() {
      return {
        width: ref !== null && ref !== void 0 && ref.current ? ref.current.offsetWidth : 0,
        height: ref !== null && ref !== void 0 && ref.current ? ref.current.offsetHeight : 0
      };
    };
    var handleResize = function handleResize() {
      setDimension(getDimension());
    };
    if (ref !== null && ref !== void 0 && ref.current) {
      setDimension(getDimension());
    }
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, [ref]);
  return dimension;
};

export { useDimension };
//# sourceMappingURL=useDimension.js.map
